import { useMemo } from 'react';
import { SelectOption } from './select-option-item.component';
import { getSelectedHiddenOptions, getSelectedOptionsLabel, hasPlaceholderSelectedOption } from './select.business';
import { SelectPropsValue } from './select.type';

interface VirtualRow {
    index: number;
}

interface SelectItemToRender {
    index: number;
    option: SelectOption;
}

interface SelectOptionsProjection {
    itemsToRender: SelectItemToRender[];
    selectedOptionsLabel: string;
    isSelectedOptionPlaceholder: boolean;
    hiddenOptions: SelectOption[];
}

const NO_HIDDEN_OPTIONS: SelectOption[] = [];

export const useSelectOptionsProjection = (
    options: SelectOption[],
    value: SelectPropsValue,
    virtualRows: VirtualRow[],
    shouldVirtualize: boolean
): SelectOptionsProjection => {
    const itemsToRender = shouldVirtualize
        ? virtualRows.map(({ index }) => ({ index, option: options[index] }))
        : options.map((option, index) => ({ index, option }));

    const selectedOptionsLabel = useMemo(() => getSelectedOptionsLabel(options, value), [options, value]);

    const isSelectedOptionPlaceholder = useMemo(() => hasPlaceholderSelectedOption(options, value), [options, value]);

    const hiddenOptions = shouldVirtualize
        ? getSelectedHiddenOptions(
              options,
              value,
              itemsToRender.map(({ option }) => option)
          )
        : NO_HIDDEN_OPTIONS;

    return { itemsToRender, selectedOptionsLabel, isSelectedOptionPlaceholder, hiddenOptions };
};
